import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frCommon  from './locales/fr/common.json';
import frHome    from './locales/fr/home.json';
import frAbout   from './locales/fr/about.json';
import frPrograms from './locales/fr/programs.json';
import frContact from './locales/fr/contact.json';
import frNews    from './locales/fr/news.json';
import frGalerie from './locales/fr/galerie.json';
import frAppel   from './locales/fr/appel.json';
import frLegal   from './locales/fr/legal.json';
import frImpact  from './locales/fr/impact.json';
import frPartners from './locales/fr/partners.json';
import frResources from './locales/fr/resources.json';
import frAnnuaire from './locales/fr/annuaire.json';
import frCandidature from './locales/fr/candidature.json';
import frCohortes from './locales/fr/cohortes.json';
import frDesabonnement from './locales/fr/desabonnement.json';
import frEnquete from './locales/fr/enquete.json';
import frProfil  from './locales/fr/profil.json';

import enCommon  from './locales/en/common.json';
import enHome    from './locales/en/home.json';
import enAbout   from './locales/en/about.json';
import enPrograms from './locales/en/programs.json';
import enContact from './locales/en/contact.json';
import enNews    from './locales/en/news.json';
import enGalerie from './locales/en/galerie.json';
import enAppel   from './locales/en/appel.json';
import enLegal   from './locales/en/legal.json';
import enImpact  from './locales/en/impact.json';
import enPartners from './locales/en/partners.json';
import enResources from './locales/en/resources.json';
import enAnnuaire from './locales/en/annuaire.json';
import enCandidature from './locales/en/candidature.json';
import enCohortes from './locales/en/cohortes.json';
import enDesabonnement from './locales/en/desabonnement.json';
import enEnquete from './locales/en/enquete.json';
import enProfil  from './locales/en/profil.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        common:   frCommon,
        home:     frHome,
        about:    frAbout,
        programs: frPrograms,
        contact:  frContact,
        news:     frNews,
        galerie:  frGalerie,
        appel:    frAppel,
        legal:    frLegal,
        impact:   frImpact,
        partners: frPartners,
        resources: frResources,
        annuaire: frAnnuaire,
        candidature: frCandidature,
        cohortes: frCohortes,
        desabonnement: frDesabonnement,
        enquete:  frEnquete,
        profil:   frProfil,
      },
      en: {
        common:   enCommon,
        home:     enHome,
        about:    enAbout,
        programs: enPrograms,
        contact:  enContact,
        news:     enNews,
        galerie:  enGalerie,
        appel:    enAppel,
        legal:    enLegal,
        impact:   enImpact,
        partners: enPartners,
        resources: enResources,
        annuaire: enAnnuaire,
        candidature: enCandidature,
        cohortes: enCohortes,
        desabonnement: enDesabonnement,
        enquete:  enEnquete,
        profil:   enProfil,
      },
    },
    lng: localStorage.getItem('envol_lang') || 'fr',
    fallbackLng: 'fr',
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'envol_lang',
    },
  });

export default i18n;
